import React, { Fragment } from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './privacy.css'

const Privacy = (props) => {
  return (
    <div className="privacy-container1">
      <Helmet>
        <title>
          Privacy - GESVET – App para digitalizar el trabajo veterinario en
          campo
        </title>
        <meta
          name="description"
          content="Solución móvil para veterinarios de ganado bovino. Registro de animales, estadísticas de preñez, revisación de toros e informes profesionales."
        />
        <meta
          property="og:title"
          content="Privacy - GESVET – App para digitalizar el trabajo veterinario en campo"
        />
        <meta
          property="og:description"
          content="Solución móvil para veterinarios de ganado bovino. Registro de animales, estadísticas de preñez, revisación de toros e informes profesionales."
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/c5d5ed29-b3ec-4d24-824a-945896b13c65/a683aef5-7460-454d-aed7-588f9c14e5a7?org_if_sml=1&amp;force_format=original"
        />
        <link rel="canonical" href="https://www.gesvet.com.ar/privacy" />
        <meta property="og:url" content="https://www.gesvet.com.ar/privacy" />
      </Helmet>
      <Navigation></Navigation>
      <section className="support-section">
        <div className="support-container">
          <div className="support-split">
            <div className="support-info">
              <h2 className="section-title">Soporte y contacto</h2>
              <p className="section-content">
                <span>Última modificación: 14 de enero de 2021</span>
                <span>
                  El respeto a tu privacidad está totalmente garantizado.
                </span>
                <br></br>
                <br></br>
                <span>
                  1 - A través de esta aplicación no se recaban datos de
                  carácter personal de los usuarios.
                </span>
                <br></br>
                <br></br>
                <span>2 - No se registran direcciones IP.</span>
                <br></br>
                <br></br>
                <span>
                  3 - No se accede a las cuentas de correo de los usuarios.
                </span>
                <br></br>
                <br></br>
                <span>
                  4 - La aplicación no guarda datos ni hace seguimientos sobre
                  tiempos y horarios de utilización.
                </span>
                <br></br>
                <br></br>
                <span>
                  5 - La aplicación no guarda información relativa a tu
                  dispositivo como, por ejemplo, fallos, actividad del sistema,
                  ajustes del hardware, tipo de navegador, idioma del navegador.
                </span>
                <br></br>
                <br></br>
                <span>
                  6 - La aplicación no accede a tus contactos ni agendas.
                </span>
                <br></br>
                <br></br>
                <span>
                  7 - La aplicación no recopila información sobre tu ubicación
                  real.
                </span>
                <br></br>
                <br></br>
                <span>8 - Remarketing con Google AdMob</span>
                <br></br>
                <br></br>
                <span>
                  Proveedores como Google, utilizan cookies de primer nivel y
                  cookies de terceros u otros identificadores de terceros para
                  compilar datos sobre las interacciones de los usuarios con las
                  impresiones de anuncios y otras funciones de servicio de
                  anuncios.
                </span>
                <br></br>
                <br></br>
                <span>
                  9 - Clasificación por edades: IARC 3+ - Clasificación para
                  mayores de 3 años.
                </span>
                <br></br>
                <br></br>
                <span>
                  10 – GesVet, no Google, es el único responsable de GesVet y su
                  contenido.
                </span>
                <br></br>
                <br></br>
                <span>
                  11 - Mantenimiento y Soporte: GesVet, no Google, estará
                  obligado a proporcionar dicho mantenimiento o soporte.
                </span>
                <br></br>
                <br></br>
                <span>12 - Cambios en nuestra Política de Privacidad:</span>
                <br></br>
                <br></br>
                <span>
                  Nuestra Política de Privacidad puede cambiar de vez en cuando.
                </span>
                <br></br>
                <br></br>
                <span>
                  Publicaremos cualquier cambio de política de privacidad en
                  esta página, por lo que debe revisarla periódicamente.
                </span>
                <br></br>
                <br></br>
                <span>13 - Contacto:</span>
                <br></br>
                <br></br>
                <span>
                  Si tiene alguna pregunta sobre esta Política o para informar
                  de cualquier violación de la Política, envíe un correo
                  electrónico a: tonicastelletti@gmail.com
                </span>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <span>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </p>
            </div>
            <div className="support-visual">
              <img
                alt="image"
                src="/images/privacy-1500w.jpeg"
                className="privacy-image support-img"
              />
            </div>
          </div>
          <div className="privacy-container2">
            <div className="privacy-container3">
              <Script
                html={`<script>
(function(){
  // No JavaScript required for this compact grid layout.
})()
</script>`}
              ></Script>
            </div>
          </div>
        </div>
        <dialog id="manualModal" className="manual-dialog">
          <div className="dialog-header">
            <h2 className="section-subtitle">
              Manual de Configuración de Bastones
            </h2>
            <button id="closeManualBtn" className="close-btn">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  d="M18 6L6 18M6 6l12 12"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </button>
          </div>
          <div className="dialog-body">
            <div className="manual-step">
              <strong>Paso 1:</strong>
              <span>
                {' '}
                Vincular el Bluetooth del dispositivo Android al bastón.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </div>
            <div className="manual-step">
              <strong>Paso 2:</strong>
              <span>
                {' '}
                Configuración según modelo (HR4/5, True Test, Syno, AllFlex).
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </div>
            <div className="manual-step">
              <strong>Paso 3:</strong>
              <span>
                {' '}
                Dentro de GESVET, presionar el botón de lectura y seleccionar el
                dispositivo.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </div>
            <p className="section-content">
              Para configuraciones avanzadas (Modo HID, SPP o Slave), consulte
              directamente vía WhatsApp.
            </p>
          </div>
        </dialog>
      </section>
      <div className="privacy-container4">
        <div className="privacy-container5">
          <Script
            html={`<script>
(function(){
  // No JavaScript required for this professional grid layout as per specifications.
  // Using semantic HTML and CSS Grid for optimal performance and accessibility.
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer
        text={
          <Fragment>
            <span className="privacy-text74">Soporte</span>
          </Fragment>
        }
        text1={
          <Fragment>
            <span className="privacy-text75">Aplicacion</span>
          </Fragment>
        }
        text2={
          <Fragment>
            <span className="privacy-text76">Home</span>
          </Fragment>
        }
        text3={
          <Fragment>
            <span className="privacy-text77">Bluetooth</span>
          </Fragment>
        }
        text4={
          <Fragment>
            <span className="privacy-text78">Soporte1</span>
          </Fragment>
        }
      ></Footer>
    </div>
  )
}

export default Privacy
